import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { useMemo } from 'react';
export const useThreadSources = () => {
    const { firstResult, lastResult, results } = useResults();
    return useMemo(() => {
        const firstResultSources = firstResult?.sources?.sources ?? EMPTY_ARRAY;
        const lastResultSources = lastResult?.sources?.sources ?? EMPTY_ARRAY;
        const threadSources = results.flatMap((result) => result.sources?.sources || EMPTY_ARRAY);
        return {
            threadSources,
            firstResultSources,
            lastResultSources,
        };
    }, [firstResult?.sources, lastResult?.sources, results]);
};
//# sourceMappingURL=useThreadSources.js.map